import React from 'react';
import { motion } from 'framer-motion';

const BoardMemberCard = ({ name, position, role, link }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="bg-white p-6 rounded-lg shadow-md h-full"
    >
      <h3 className="text-xl font-bold text-gray-800 mb-1">
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 hover:underline"
          >
            {name}
          </a>
        ) : (
          name
        )}
      </h3>
      <p className="text-primary-600 font-medium mb-2">{position}</p>
      <p className="text-gray-600">{role}</p>
    </motion.div>
  );
};

export default BoardMemberCard;
